import { Button, ClickEvent, DataSourceExecutionEvent, Layout, LayoutProps, SlideoutDecorator, Snackbar, Table } from "@mcleod/components";
import { Api } from "@mcleod/core";
import { AutogenLayoutCarrierConnectControl } from "./autogen/AutogenLayoutCarrierConnectControl";
import { CarrierConnectAvailableCarriers } from "./CarrierConnectAvailableCarriers";

interface RatewareControlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class CarrierConnectControl extends AutogenLayoutCarrierConnectControl {

    constructor(props?: Partial<RatewareControlLayoutProps>) {
        super(props);
    }

    async onLoad() {
        this.buttonTestConnection.doOnDataSourceChanged = (ds, value) => {  this.buttonTestConnection.enabled = !value; }
        this.mainDataSource.addHasChangedComponent(this.buttonTestConnection);

        this.buttonViewAvailableCarriers.doOnDataSourceChanged = (ds, value) => { this.buttonViewAvailableCarriers.enabled = !value; }
        this.mainDataSource.addHasChangedComponent(this.buttonViewAvailableCarriers);

        this.buttonTestConnection.disabledTooltip = "You cannot Test Connection because something has changed or service not Active";
        this.buttonViewAvailableCarriers.disabledTooltip = "You cannot View Available Carriers because something has changed or service not Active";
    }

    sourceContractManagementControlAfterExecution(event: DataSourceExecutionEvent) {
        this.buttonTestConnection.enabled = this.checkboxActive.checked;
        this.buttonViewAvailableCarriers.enabled = this.checkboxActive.checked;
    }

    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            this.mainDataSource?.activeRow?.set("id", vendorId);
            await this.mainDataSource.post();
            return true;
        } catch (error) {
            return false;
        }
    }

    buttonTestConnectionOnClick(event: ClickEvent) {
        const createButton: Button = event.target as Button;
        createButton.busy = true;
        Api.post("lme/powerbroker/carrier-connect-api-control").then(result => {
            createButton.busy = false;
            if (result) {
                const message: string = result?.data[0]?.message;
                Snackbar.showSnackbar(message);
            }
        });
    }

    buttonViewAvailableCarriersOnClick(event: ClickEvent) {
        const layout: CarrierConnectAvailableCarriers = Layout.getLayout("lme/powerbroker/ltl/CarrierConnectAvailableCarriers") as CarrierConnectAvailableCarriers;
        const table = event.target as Table;

        const slideoutDecorator = new SlideoutDecorator({
            title: "Available Carriers",
            layout: layout,
            fillVerticalSpace: true,
            width: 1000,
            overlayProps: { greyedBackground: true },
            onClose: async (cancelled: boolean) => {
                layout.slideOut();
            },
            layoutLoadListeners: async () => {
                await Api.post("lme/powerbroker/carrier-connect-available-carriers").then(async response => {
                    const availableCarriers = response.data[0].available_carriers;
                    if (availableCarriers) {
                        layout.tableAvailableCarriers.data = availableCarriers;
                        layout.tableAvailableCarriers.displayData(null, availableCarriers, 0);
                    }
                }).catch(reason => {
                    Snackbar.showWarningSnackbar("Available Carriers: " + reason.messages[0]);
                });
            }
        });
    }
}
